import React from "react";
import {
  Box,
  Grid,
  Button,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  Link
} from "react-router-dom";
import {
  ActivationSmallCard
} from "../../../../../components";
import getTrans from "../../../../../languages/getTrans";

const SectionItems = ({ title, Icon, type, items }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <div className={classes.head}>
        <div className={classes.headIcon}>{Icon}</div>
        <div className={classes.headTitle}>{title}</div>
        <Button
          to={'/services'}
          component={Link}
          variant="contained"
          className={classes.headButton}
        >{getTrans('sectionItems.Все')}</Button>
      </div>
      <div className={classes.body}>
        <Grid container spacing={1}>
          {items.map((item) => (
            <Grid key={item.id} xs={4} item>
              <ActivationSmallCard
                name={item.name}
                slug={item.slug}
                imageId={item.icon_id || item.icon}
              />
            </Grid>
          ))}
        </Grid>
      </div>
    </Box>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: "12px 8px",
    borderRadius: "20px",
    boxSizing: "border-box",
  },

  head: {
    gap: "8px",
    display: "flex",
    marginBottom: "12px",
    alignItems: "center",
  },
  headIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24, height: 24,
  },
  headTitle: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: "24px",
    letterSpacing: "0.03em",
    color: theme.palette.text.primary,
  },
  headButton: {
    height: "30px",
    marginLeft: "auto",
    backgroundColor: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",

    fontSize: 14,
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.palette.text.main,

    "&:focus,&:active,&:hover": {
      backgroundColor: "rgba(255,255,255,0.1)",
    }
  },

  body: {},
}));

export default SectionItems
